import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import { getImageUrl } from "./utils/image";
import { useActivityLogger } from "./hooks/useActivity";
import { getRandomThumbnail } from "./utils/randomImage";
import { useSearch } from "./contexts/SearchContext";

export default function AdminArticle() {
  const { searchQuery } = useSearch();
  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const navigate = useNavigate();
  const { logAdminActivity } = useActivityLogger();
  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await api.get("/articles/all");
        setArticles(res.data);
        // console.log("Artikel berhasil diambil:", res.data);
      } catch (err) {
        console.error("Gagal mengambil artikel", err);
      }
    };
    // Log activity
    logAdminActivity(
      "view",
      "view_admin_article_list",
      "article",
      null,
      "admin",
      "success",
      "",
      "Admin melihat daftar artikel edukasi"
    );
    fetchArticles();
  }, []);
  
  const handleDeleteArticle = async (articleId) => {
    try {
      await api.delete(`/articles/${articleId}`);
      setArticles(articles.filter(article => article.ID !== articleId));
      logAdminActivity(
        "delete",
        "delete_admin_article",
        "article",
        articleId,
        "admin",
        "success",
        "",
        `Admin menghapus artikel dengan ID ${articleId}`
      );
      alert("Artikel berhasil dihapus");
    } catch (err) {
      console.error("Gagal menghapus artikel", err);
      logAdminActivity(
        "delete",
        "delete_admin_article",
        "article",
        articleId,
        "admin",
        "error",
        err.message,
        `Admin gagal menghapus artikel dengan ID ${articleId}`
      );
    }
  };
  const filteredArticles = articles.filter(article =>
    article.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    article.author?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredArticles.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredArticles.length / itemsPerPage);

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-4 rounded shadow">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Artikel Edukasi</h2>
            <button
              onClick={() => navigate("/admin/article/upload")}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              + Upload Artikel
            </button>
          </div>

          <table className="w-full text-sm">
            <thead className="border-b">
              <tr>
                {/* <th className="py-2 text-left">Waktu Upload</th> */}
                <th className="py-2 text-left w-1/8 md:w-1/6 ">Tanggal Publikasi</th>
                <th className="py-2 text-left w-1/8 md:w-1/6">Kategori</th>
                <th className="py-2 text-left w-1/8 md:w-1/6">Thumbnail</th>
                <th className="py-2 text-left w-1/8 md:w-1/4">Judul</th>
                <th className="py-2 text-left w-1/8 md:w-1/6">Penulis</th>
                <th className="py-2"></th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((article) => (
                <tr key={article.ID} className="border-b">
                  {/* <td className="py-2">{new Date(article.CreatedAt).toLocaleString("id-ID")}</td> */}
                  <td className="py-2">
                    {new Date(article.published_date).toLocaleDateString(
                      "id-ID"
                    )}
                  </td>
                  <td className="py-2">{article.kategori}</td>
                  <td className="py-2">
                    <img
                      src={getImageUrl(article.image) ?? getRandomThumbnail(article.title)}
                      alt={article.title}
                      className="h-20 rounded"
                    />
                  </td>
                  <td className="py-2">{article.title}</td>
                  <td className="py-2">{article.author}</td>
                  <td className="py-2 align-middle">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() =>
                          navigate("/admin/article/edit/" + article.ID)
                        }
                      >
                        <img
                          src="/icon-edit.png"
                          alt="Edit"
                          className="h-5 w-5"
                        />
                      </button>
                      <button 
                      onClick={() => handleDeleteArticle(article.ID)}
                      >
                        <img
                          src="/icon-trash.png"
                          alt="Delete"
                          className="h-5 w-5"
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-4 gap-1">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="border px-2 py-1 rounded"
            >
              &lt;
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`border px-2 py-1 rounded ${currentPage === i + 1 ? "bg-blue-500 text-white" : ""}`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              className="border px-2 py-1 rounded"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
